import { render, staticRenderFns } from "./Swagger.vue?vue&type=template&id=5690f2de&scoped=true"
import script from "./Swagger.vue?vue&type=script&lang=js"
export * from "./Swagger.vue?vue&type=script&lang=js"
import style0 from "./Swagger.vue?vue&type=style&index=0&id=5690f2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690f2de",
  null
  
)

export default component.exports